import { RootState } from "../../../redux-store";

export const selectNowMillisUtc = (state: RootState) => state.app.time.nowUtc;
